import classNames from 'classnames';
import { useParams } from 'react-router';

import { useTranslate } from '../../../../../i18n/useTranslationModules';
import { ContentEditors, PageModule, Session } from '../../../../../types/working-model';
import { ParamsProps } from '../../../live-event';
import { getStylingOverrides } from '../../../utils';
import { TypographyItem } from '../../../../general-ui/typography-item/typography-item';
import { getDefaultModuleAlignment, getTextValue } from '../../../../../utils/utils';
import RenderEditorDescription from '../../../../general-ui/editable-text/render-editor-description';
import { useTypedSelector } from '../../../../../store/reducers/use-typed-selector';
import '../../../../../scss/live-event/base/session/description.scss';

interface DescriptionProps {
	module: PageModule;
	template: string;
	session: Session;
}

const SessionDescription: React.FC<DescriptionProps> = ({ module, template, session }) => {
	const { t: sessionT } = useTranslate(`session.${session.session}`);
	const params: ParamsProps = useParams();

	const eventBundleContentEditor = useTypedSelector(state => state.LiveEventReducer.eventBundle?.settings?.content_editor);
	const workingEventContentEditor = useTypedSelector(state => state.CreateEventReducer.workingEvent?.settings?.content_editor);
	const contentEditor = eventBundleContentEditor || workingEventContentEditor;

	const language = params?.language || 'en';

	const { styling_overrides, content } = module;

	const stylingOverrides = getStylingOverrides(styling_overrides);
	const {
		titleOverrides,
		customHeadingOverrides,
		descriptionOverrides
	} = stylingOverrides;

	const { custom_heading, title, description } = getTextValue(content, language);

	return (
		<section className={classNames(
			'session-module description',
			stylingOverrides.backgroundColor,
			template
		)}
			style={stylingOverrides.backgroundImg}
		>
			<TypographyItem
				tagName="p"
				className={classNames('evt-heading-5 custom-title', customHeadingOverrides)}
				template={template}
			>
				{sessionT(`session.${session.session}:description.${module.id}.heading`, sessionT(`session.${session.session}:description.heading`, custom_heading))}
			</TypographyItem>
			<div className="description-content">
				<TypographyItem
					tagName="h3"
					className={classNames('evt-heading-3 title', titleOverrides)}
					template={template}
				>
					{sessionT(`session.${session.session}:description.${module.id}.title`, sessionT(`session.${session.session}:description.title`, title))}
				</TypographyItem>
				<TypographyItem
					tagName="div"
					className={classNames('evt-body-text-1 description')}
					template={template}
				>
					<RenderEditorDescription
						description={sessionT(`session.${session.session}:description.${module.id}.description`, sessionT(`session.${session.session}:description.description`, description))}
						descriptionOverrides={classNames(descriptionOverrides)}
						useNew={contentEditor === ContentEditors.quill}
						defaultTextAlignment={getDefaultModuleAlignment(module, template)}
					/>
				</TypographyItem>
			</div>
		</section>
	);
};

export default SessionDescription;